var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurveGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 39,
    viewBox: "0 0 101 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00421067C0 0.00421067 2.6232 0.00378208 9 0.00421067H0Z",
    fill: "#000F06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00421067C0 0.00421067 2.6232 0.00378208 9 0.00421067H92.6959C98.791 -0.00545037 101 0.00421067 101 0.00421067H92.6959C92.631 0.00431346 92.5657 0.00441844 92.5 0.00452564C67.8043 0.0448008 75.9333 39.1664 51.1918 38.9992C26.5907 38.8329 33.544 0.00586032 9 0.00421067H0Z",
    fill: "#000F06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveGreen);
export default __webpack_public_path__ + "static/media/CurveGreen.996184858cdd3e8e39e4c52ec02c5fb5.svg";
export { ForwardRef as ReactComponent };